<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader.vue";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Swal from "sweetalert2";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxGroupPanel, DxGrouping, DxFilterRow,
  DxPager, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import {ref} from "vue";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: {
    Layout, PageHeader,
    DxDataGrid, DxColumn,
    DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxGroupPanel, DxGrouping, DxFilterRow,
    DxPager,  DxRemoteOperations,
    Loader
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop};
  },

  watch: {
    'movSpeTrkFinData.valoradic2': {
      handler() {
        this.calculaTotal()
      }
    }
  },

  data() {

    return {
      title: "Financeiro Shopee",
      items: [
        {
          text: "Financeiro",
          href: "/"
        },
        {
          text: "Financeiro Shopee",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,

      errosValid: null,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,

      showModalFinanc: false,
      updating: false,
      movSpeTrkFinData: {},


    };
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov_shopee-list_0')
    this.atualizaDataList()
  },

  methods: {

    salvarFin(){
      console.log('salvarFin')
      api.post(`${getBaseUrl()}api/movspetrkfin`, {
        movSpeTrkFinData: this.movSpeTrkFinData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.showModalFinanc = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
        this.atualizaDataList()
      })
    },


    calculaTotal(){
      console.log('calculaTotal')
      let total = 0
      if (this.movSpeTrkFinData.valor)
        total = parseFloat(this.movSpeTrkFinData.valor)
      if (this.movSpeTrkFinData.valorveic)
        total += parseFloat(this.movSpeTrkFinData.valorveic)
      if (this.movSpeTrkFinData.valorefic)
        total += parseFloat(this.movSpeTrkFinData.valorefic)
      if (this.movSpeTrkFinData.valoradic1)
        total += parseFloat(this.movSpeTrkFinData.valoradic1)
      if (this.movSpeTrkFinData.valoradic2)
        total += parseFloat(this.movSpeTrkFinData.valoradic2)
      this.movSpeTrkFinData.total = total
    },

    abrirFinanceiro(){
      console.log('abrirFinanceiro')
      this.$router.push(`/movs/editarded/0`)
    },

    nomeStatus(e) {
      if (e.value === "CO") {
        return 'Coletado (CO)'
      } else if (e.value === "RE") {
        return 'Rota Entrega (RE)'
      }
    },

    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))
      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    carregouGrid(e){
      console.log('carregouGrid')
      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
      this.title = `(${e.component.totalCount()}) Financeiro Shopee: ${dtIniFormated} - ${dtFimFormated}`
    },


    atualizaDataList(){
      console.log('atualizaDataList_mov')
      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      this.updating = false
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions){
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }

          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/movshptrkfins`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data_0')
            console.log(response.data[0])

            response.data[0].forEach((financ) => {
              if (financ.data){
                financ.data_fmt = moment(financ.data).format('DD/MM/YYYY')
              }
            })


            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      this.movSpeTrkFinData = row.data
      this.showModalFinanc = true
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "mov_status") {
          const valStatus = e.data.mov_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CF':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'ENP':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'ECR':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'EAT':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'NED':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'NEF':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SCT':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'CCT':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'TRA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'CAN':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        } else if (e.column.dataField === "diasentrega") {
          const valDias = e.data.diasentrega
          let corDias = null
          if (!valDias) {
            corDias = 'rgba(0,0,0,0.38)'
          } else if (valDias < 0) {
            corDias = 'rgba(146,20,0,0.5)'
          } else if (valDias > 0) {
            corDias = 'rgba(33,78,0,0.5)'
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corDias}`;
        }


      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },


    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"  @click="showModalPeriodo = true"/>


    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">
      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>


        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            sort-order="desc"
            data-field="id"
            caption="ID"
            alignment="right"
            data-type="number"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="taskid"
            caption="Task ID"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="periodo"
            caption="Período"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="data"
            caption="Data"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="motorista"
            caption="Motorista"
            :width="180"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="tipo"
            caption="Tipo"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="placa"
            caption="Placa"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="remessa"
            caption="Remessa"
            alignment="right"
            data-type="number"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entregue"
            caption="Entregue"
            alignment="right"
            data-type="number"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="falha"
            caption="Falha"
            alignment="right"
            data-type="number"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="eficacia"
            caption="Eficácia"
            alignment="right"
            data-type="number"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="obs"
            caption="Obs"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="valorveic"
            caption="Valor Veic."
            alignment="right"
            data-type="number"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="valor"
            caption="Variável"
            alignment="right"
            data-type="number"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="valorefic"
            caption="Valor Efic."
            alignment="right"
            data-type="number"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="valoradic1"
            caption="Valor Domingo"
            alignment="right"
            data-type="number"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="valoradic2"
            caption="Valor Feriado"
            alignment="right"
            data-type="number"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="total"
            caption="Valor Total"
            alignment="right"
            data-type="number"
            :format="formatDecimal"
            :fixed="true"
            fixed-position="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>
      </DxDataGrid>
    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>
  </Layout>



  <b-modal size="xl"
           :title="'Detalhes Financeiro Shopee (' + movSpeTrkFinData.id + ')'"
           v-model="showModalFinanc" centered hide-footer>
    <div>

      <div class="card">
        <div class="card-body">

          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-1
                 class="text-dark"
                 href="javascript: void(0);">
                Dados Principais
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
            <b-card-body>

              <div class="row">

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="id">ID</label>
                    <input id="id" v-model="movSpeTrkFinData.id"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="ID"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="taskid">Task ID</label>
                    <input id="taskid" v-model="movSpeTrkFinData.taskid"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Task ID"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="pessoa_id">ID Pessoa</label>
                    <input id="pessoa_id" v-model="movSpeTrkFinData.pessoa_id"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="ID Pessoa"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="motorid">ID Motorista</label>
                    <input id="motorid" v-model="movSpeTrkFinData.motorid"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="ID Motorista"/>
                  </div>
                </div>


                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="periodo">Período</label>
                    <input id="periodo" v-model="movSpeTrkFinData.periodo"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Período"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="datafmt">Data</label>
                    <input id="datafmt" v-model="movSpeTrkFinData.data_fmt"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Data"/>
                  </div>
                </div>


              </div>

              <div class="row">


                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="motorista">Motorista</label>
                    <input id="motorista" v-model="movSpeTrkFinData.motorista"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Motorista"/>
                  </div>
                </div>


                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="tipo">Tipo</label>
                    <input id="tipo" v-model="movSpeTrkFinData.tipo"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Tipo"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="placa">Placa</label>
                    <input id="placa" v-model="movSpeTrkFinData.placa"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Placa"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="obs">Obs</label>
                    <input id="obs" v-model="movSpeTrkFinData.obs"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Obs"/>
                  </div>
                </div>


              </div>

              <div class="row">

                <div class="col-md-4 text-end">
                </div>


                <div class="col-md-2 text-end">
                  <div class="mb-3">
                    <label for="remessa">Remessa</label>
                    <input id="remessa"
                           v-model="movSpeTrkFinData.remessa"
                           type="number"
                           class="form-control text-end"
                           :disabled="true"
                           placeholder="Remessa"/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <div class="mb-3">
                    <label for="entregue">Entregue</label>
                    <input id="entregue"
                           v-model="movSpeTrkFinData.entregue"
                           type="number"
                           class="form-control text-end"
                           :disabled="true"
                           placeholder="Entregue"/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <div class="mb-3">
                    <label for="falha">Falha</label>
                    <input id="falha"
                           v-model="movSpeTrkFinData.falha"
                           type="number"
                           class="form-control text-end"
                           :disabled="true"
                           placeholder="Falha"/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <div class="mb-3">
                    <label for="eficacia">Eficácia (%)</label>
                    <input id="eficacia"
                           v-model="movSpeTrkFinData.eficacia"
                           type="number"
                           class="form-control text-end"
                           :disabled="true"
                           placeholder="Eficácia (%)"/>
                  </div>
                </div>

              </div>

              <div class="row">


                <div class="col-md-2 text-end">
                  <div class="mb-3">
                    <label for="variavel">Variável (R$)</label>
                    <input id="variavel"
                           v-model="movSpeTrkFinData.valor"
                           type="number"
                           class="form-control text-end"
                           :disabled="true"
                           placeholder="Variável (R$)"/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <div class="mb-3">
                    <label for="valorveic">Veículo (R$)</label>
                    <input id="valorveic"
                           v-model="movSpeTrkFinData.valorveic"
                           type="number"
                           class="form-control text-end"
                           :disabled="true"
                           placeholder="Veículo (R$)"/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <div class="mb-3">
                    <label for="valorefic">Ad. Eficiência (R$)</label>
                    <input id="valorefic"
                           v-model="movSpeTrkFinData.valorefic"
                           type="number"
                           class="form-control text-end"
                           :disabled="true"
                           placeholder="Ad. Eficiência (R$)"/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <div class="mb-3">
                    <label for="valoradic1">Ad. Domingo (R$)</label>
                    <input id="valoradic1"
                           v-model="movSpeTrkFinData.valoradic1"
                           type="number"
                           class="form-control text-end"
                           :disabled="true"
                           placeholder="Ad. Domingo (R$)"/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <div class="mb-3">
                    <label for="valoradic2">Ad. Feriado (R$)</label>
                    <input id="valoradic2"
                           v-model="movSpeTrkFinData.valoradic2"
                           type="number"
                           class="form-control text-end"
                           :disabled="false"
                           placeholder="Ad. Feriado (R$)"/>
                  </div>
                </div>

                <div class="col-md-2 text-end">
                  <div class="mb-3">
                    <label for="total">Total (R$)</label>
                    <input id="total"
                           v-model="movSpeTrkFinData.total"
                           type="number"
                           class="form-control text-end"
                           :disabled="true"
                           placeholder="Total (R$)"/>
                  </div>
                </div>


              </div>


            </b-card-body>
          </b-collapse>

        </div>
      </div>

      <div class="row">
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFinanc = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

          <b-button variant="success" class="ms-1" @click="salvarFin">
            <i class="bx bx-check-circle font-size-16 align-middle me-2"></i>
            Salvar
          </b-button>

        </div>
      </div>
    </div>


  </b-modal>

</template>
